import { Component, OnInit } from '@angular/core';

import { SecurityService } from '../../core/security/security.service';
import { SendgridApiService } from '../../core/sendgrid-api/sendgrid-api.service';
import { UserJsVm } from '../generated/Administration/Models/User/JavaScript/UserJsVm';
import { SendgridBounceVm, SendgridUserBounceResponse } from '../models/SendgridUserBounceResponse';

@Component({
    selector: 'pcg-bounce-alert',
    templateUrl: './bounce-alert.component.html',
    styleUrls: ['./bounce-alert.component.scss'],
    standalone: false
})
export class BounceAlertComponent implements OnInit {

    user!: UserJsVm;
	bouncedEmailData!: SendgridBounceVm;
	userIsBounced: boolean = false;
	errorMsg!: string;

	constructor(
        private sendgridApiService: SendgridApiService
        , private securityService: SecurityService
    ) { }

	ngOnInit(): void {
		this.getActiveUser();
		if (this.user != null) { this.getBouncedEmailMessages(this.user.userName ?? ""); }
	}

	getBouncedEmailMessages(username: string) {
		this.sendgridApiService.getIsBouncedResponse(username).subscribe((response: SendgridUserBounceResponse) => {
			if (response.isBounced) {
				this.userIsBounced = true;
				this.bouncedEmailData = response.sendgridBounceInfo;
			}
		});
	}

	getActiveUser() { this.securityService.user$.subscribe(user => { if (user) { this.user = user; } }); }

	removeFromBounceList() {		
        this.sendgridApiService.removeBouncedUser(this.user?.email ?? "").subscribe(resp => {
            if (resp == 204) { this.userIsBounced = false; } 
            else { this.errorMsg = 'Unable to remove user from the bounce list at this time. Please try again later.'; }
        });
	}
}

